import React from 'react';
import {
  Box,
  Circle,
  CircleDiv,
  Div,
  First,
  Line,
  Longline,
  Main,
  Second,
  ShortLine,
  Smallcircle,
  Third,
  UserLogo
} from './styles';

export default function ProjectAllLoading() {
  return (
    <Main>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
      <Box>
        <First>
          <CircleDiv>
            <Circle className='loading-animation'></Circle>
          </CircleDiv>
          <Div>
            <Longline className='loading-animation'></Longline>
            <ShortLine className='loading-animation'></ShortLine>
          </Div>
        </First>
        <Second>
          <Smallcircle className='loading-animation'></Smallcircle>
          <Line className='loading-animation'></Line>
        </Second>
        <Third>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
          <UserLogo className='loading-animation'></UserLogo>
        </Third>
      </Box>
    </Main>
  );
}
